import{useSelector}from'react-redux';const usePageContent=()=>{return useSelector(state=>state.pageContent);};export default usePageContent;